import { type ReactNode, useMemo } from "react";
import { StyleSheet, type TextProps, type ViewProps } from "react-native";
import { ListingGroup } from "~/components/layout/ListingGroup";
import { Article } from "~/components/layout/resources/Article";
import { NoRecords } from "~/components/layout/text";
import { useResources } from "~/providers/ResourcesProvider";
import { filled } from "~/util";

export type LatestBlogsProps = {
    count?: number;
    title?: ReactNode;
    titleProps?: Omit<TextProps, "children">;
    bodyProps?: Omit<ViewProps, "children">;
};

export const LatestBlogs = ({
    count = 2,
    title = "Latest blog posts",
    bodyProps,
    ...listingProps
}: LatestBlogsProps) => {
    const { blogs } = useResources();

    const articles = useMemo(() => blogs.slice(0, count), [blogs, count]);

    return (
        <ListingGroup
            {...listingProps}
            title={title}
            bodyProps={{ ...bodyProps, style: [styles.blogs, bodyProps?.style] }}
        >
            {filled(articles) ? (
                articles.map((article) => <Article article={article} key={article.key} />)
            ) : (
                <NoRecords emptyText="No recent articles" />
            )}
        </ListingGroup>
    );
};

const styles = StyleSheet.create({
    blogs: {
        gap: 16,
        backgroundColor: "transparent",
        borderRadius: 0,
    },
});
